import { CreateTableInput } from 'aws-sdk/clients/dynamodb';

export const { STATUS_PAGE_TABLE_NAME = 'status-page' } = process.env;
export const STATUS_PAGE_TABLE_SEARCH_GSI = 'searchGSI';
export const STATUS_PAGE_TABLE_CUSTOM_DOMAIN_GSI = 'customDomainGSI';

export const STATUS_PAGE_TABLE_SCHEMA: CreateTableInput = {
  TableName: STATUS_PAGE_TABLE_NAME,
  AttributeDefinitions: [
    { AttributeName: 'id', AttributeType: 'S' },
    { AttributeName: 'userId', AttributeType: 'S' },
    { AttributeName: 'customDomain', AttributeType: 'S' },
    { AttributeName: 'created', AttributeType: 'N' },
  ],
  // getStatusPage
  KeySchema: [{ AttributeName: 'id', KeyType: 'HASH' }],
  ProvisionedThroughput: {
    ReadCapacityUnits: 1,
    WriteCapacityUnits: 1,
  },
  GlobalSecondaryIndexes: [
    {
      IndexName: STATUS_PAGE_TABLE_SEARCH_GSI,
      // findStatusPages
      KeySchema: [
        { AttributeName: 'userId', KeyType: 'HASH' },
        { AttributeName: 'created', KeyType: 'RANGE' },
      ],
      Projection: {
        ProjectionType: 'ALL',
      },
      ProvisionedThroughput: {
        ReadCapacityUnits: 1,
        WriteCapacityUnits: 1,
      },
    },
    {
      IndexName: STATUS_PAGE_TABLE_CUSTOM_DOMAIN_GSI,
      // lookupStatusPage
      KeySchema: [
        { AttributeName: 'customDomain', KeyType: 'HASH' },
        { AttributeName: 'created', KeyType: 'RANGE' },
      ],
      Projection: {
        ProjectionType: 'ALL',
      },
      ProvisionedThroughput: {
        ReadCapacityUnits: 1,
        WriteCapacityUnits: 1,
      },
    },
  ],
};
